import { FileText, Pencil, Ban, Send, RefreshCw } from "lucide-react";
import { STATUS, DOC_LABEL, money } from "./invoiceDefaults";

const btn = "inline-flex items-center gap-1 h-7 px-2 rounded-md border text-[11px] font-semibold transition-colors disabled:opacity-50";

export function StatusBadge({ status, testId }) {
  const s = STATUS[status] || { label: status, cls: "bg-slate-100 text-slate-600" };
  return <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold ${s.cls}`}>{s.label}</span>;
}

export function InvoiceHistory({ invoices, busyId, onPdf, onEdit, onCancel, onFormalize, onRefresh }) {
  const shown = (invoices || []).filter((i) => i.status !== "deleted");
  if (!shown.length) return null;
  return (
    <div data-testid="inv-history" className="rounded-xl border border-slate-200 divide-y divide-slate-100">
      {shown.map((i) => (
        <div key={i.id} data-testid={`inv-history-row-${i.id}`} className="flex flex-wrap items-center gap-2 px-3 py-2 text-[12px]">
          <StatusBadge status={i.status} testId={`inv-status-${i.id}`} />
          <span className="font-semibold text-slate-700">{DOC_LABEL[i.doc_type] || "Satış faturası"}</span>
          {i.invoice_no && <span data-testid={`inv-no-${i.id}`} className="font-mono text-slate-600">{i.invoice_no}</span>}
          <span className="tabular-nums text-slate-600">{money(i.gross_total, i.currency)}</span>
          <span className="text-slate-400">{(i.created_at || "").slice(0, 16).replace("T", " ")} · {i.created_by}</span>
          {i.error && <span data-testid={`inv-error-${i.id}`} className="basis-full text-red-600 font-medium">{i.error}</span>}
          <div className="ml-auto flex gap-1">
            {i.status === "processing" && (
              <button data-testid={`inv-refresh-${i.id}`} disabled={busyId === i.id} onClick={() => onRefresh(i)} className={`${btn} border-blue-300 text-blue-700 hover:bg-blue-50`}>
                <RefreshCw size={12} className={busyId === i.id ? "animate-spin" : ""} /> Durum
              </button>
            )}
            {i.status === "approved" && (
              <button data-testid={`inv-pdf-${i.id}`} disabled={busyId === i.id} onClick={() => onPdf(i)} className={`${btn} border-emerald-300 text-emerald-700 hover:bg-emerald-50`}>
                <FileText size={12} /> PDF
              </button>
            )}
            {["draft", "error", "failed"].includes(i.status) && (<>
              <button data-testid={`inv-edit-${i.id}`} onClick={() => onEdit(i)} className={`${btn} border-amber-300 text-amber-700 hover:bg-amber-50`}>
                <Pencil size={12} /> Düzenle
              </button>
              {i.status !== "failed" && (
                <button data-testid={`inv-formalize-${i.id}`} disabled={busyId === i.id} onClick={() => { if (window.confirm("Bu taslak RESMİ e-belge (e-Arşiv / e-Fatura) olarak kesilecek. Onaylıyor musunuz?")) onFormalize(i); }} className={`${btn} border-indigo-300 text-indigo-700 hover:bg-indigo-50`}>
                  <Send size={12} /> Resmileştir
                </button>
              )}
            </>)}
            {!["cancelled", "processing"].includes(i.status) && (
              <button data-testid={`inv-cancel-${i.id}`} disabled={busyId === i.id} onClick={() => onCancel(i)} className={`${btn} border-red-300 text-red-700 hover:bg-red-50`}>
                <Ban size={12} /> {i.status === "approved" ? "İptal et" : "Sil"}
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
